<template>
    <div class="bg">
        <div class="wrap">
            <div class="title">
                <span>{{title}}</span>
            </div>

            <div class="info">
                <div>
                    <span>医院：</span>
                    <span>{{hos}}</span>
                </div>
                <div>
                    <span>科室：</span>
                    <span>{{dept}}</span>
                </div>
                <div>
                    <span>医生：</span>
                    <span>{{name}}</span>
                </div>
<!--                <div>-->
<!--                    <span>病例分配数：</span>-->
<!--                    <span>{{number}}</span>-->
<!--                </div>-->
            </div>

            <div class="explain">
                <div class="explain-item">
                    <div style="background: #0082C5"></div>
                    <span>已通过</span>
                </div>
                <div class="explain-item">
                    <div style="background: red"></div>
                    <span>未通过</span>
                </div>
                <div class="explain-item">
                    <div style="background: orange"></div>
                    <span>审核中</span>
                </div>
            </div>

            <div class="case-wrap">
                <div :class='["case-item",(key+2)%3=="0" ? "case-margin" : ""]' v-for="(item,key) in res" v-bind:key="key">
                    <div class="case" @click="toItem(item.caseId)">
                        <div class="item-wrap" v-if="item.caseId!=-1">
                            <img src="../../assets/img/icon_yes.png" v-if="item.sysStation==1">
                            <img src="../../assets/img/icon_no.png" v-if="item.sysStation==2">
                            <img src="../../assets/img/icon_wait.png" v-if="item.sysStation==0">
                            <span>病例{{key+1}}</span>
                        </div>
                        <div class="plus-wrap" v-if="(item.caseId==-1)">
                            <img class="plus" src="../../assets/img/bplus.png">
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>

</template>

<script>
    import {index} from "@/assets/js/api";

    export default {
        name: 'HelloWorld',
        data() {
            return {
                title: "",
                hos: "",
                dept: "",
                name: "",
                number: 0,
                quota1:0,
                quota2:0,
                res: [],
                docId: "",
            }
        },
        methods: {
            toItem(caseId) {
                this.$store.state.caseId = caseId
                    if (this.$route.query.scheme==1 && caseId == -1 && this.quota1 < this.res.length) {
                        this.$toast("常规组您最多可以提交" + this.quota1 + "个案例")
                        return
                    }
                    else if(this.$route.query.scheme==2 && caseId == -1 && this.quota2 < this.res.length){
                        this.$toast("强化组您最多可以提交" + this.quota2 + "个案例")
                        return
                    }

                this.$router.push({path: "caseBase",query:{scheme:this.$route.query.scheme}})
            },
            async getIndex(docId,scheme) {
                const res = await index({docId,scheme})
                if (res.data.success == true) {
                    this.hos = res.data.data.info.hos
                    this.dept = res.data.data.info.dept
                    this.name = res.data.data.info.name
                    this.number = res.data.data.info.number
                    this.quota1 = res.data.data.info.quota1;
                    this.quota2 = res.data.data.info.quota2;


                    this.res = res.data.data.case

                    let add = {caseId: "-1"}
                    this.res.push(add)

                }
            }
        },
        mounted() {
            this.docId = this.$store.state.docId
            // console.log(this.docId,"docId")
            // console.log(this.$store,"store")
            if (this.docId == undefined) {
                this.$router.push({path: "/"})
                return
            }

            var scheme = this.$route.query.scheme
            this.title = scheme==1?"常规组":"强化组"

            this.getIndex(this.docId,scheme);
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .bg{
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
    }
    .wrap {
        width: 100%;
        max-width: 400px;
        height: 100vh;
        background: #FFF;
        overflow: scroll;
    }

    .title {
        color: #0082C5;
        font-size: 25px;
        padding-top: 5px;
    }

    .info {
        width: 90%;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        background: #0082C5;
        margin: 10px auto;
        text-align: left;
        padding: 5px;
        color: #FFF;
        font-size: 20px;

        span {
            margin: 5px;
        }
    }

    .case-wrap {
        width: 90%;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

    }

    .case-item {
        display: flex;
        align-items: center;
        margin-bottom: 5%;
        width: 30%;
    }

    .case {
        width: 100%;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: #0082C5 1px solid;
        border-radius: 10px;
    }

    .case-margin {
        margin-left: 5%;
        margin-right: 5%;
    }


    .item-wrap {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        img {
            /*margin-top: 5px;*/
            width: 90px;
            height: 60px;
            object-fit: contain;
        }

        span {
            font-size: 15px;
        }
    }

    .plus {
        width: 100px;
        height: 100px;
        object-fit: contain;
    }

    .explain {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin: 8px 5%;

        .explain-item {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-right: 15px;

            div {
                width: 12px;
                height: 12px;
            }

            span {
                color: #0082C5;
            }
        }

    }

</style>
